import { render, staticRenderFns } from "./LeaderBoardTable.vue?vue&type=template&id=2b7eda17&scoped=true&"
import script from "./LeaderBoardTable.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardTable.vue?vue&type=style&index=0&id=2b7eda17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7eda17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7eda17')) {
      api.createRecord('2b7eda17', component.options)
    } else {
      api.reload('2b7eda17', component.options)
    }
    module.hot.accept("./LeaderBoardTable.vue?vue&type=template&id=2b7eda17&scoped=true&", function () {
      api.rerender('2b7eda17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/ProgressUpdate/LeaderBoardTable.vue"
export default component.exports